import {ELeadClientStatus} from 'src/containers/LeadCompanyClients';

export default {
  inviteLink: '[en] Ваша постоянная ссылка для регистрации клиентов',
  copyInviteLink: '[en] Скопировать',
  addContact: ' contact',
  searchPlaceholder: 'quick search by client',
  th: {
    createdAt: 'Registration date',
    companyName: 'Lead name',
    status: 'Status',
  },
  tab: 'Summary',
  filters: {
    period: 'Select reporting period',
    date: 'Registration date',
    periodResult: 'Result for the period',
    contacts: 'Contacts submitted',
    leads: 'Leads created',
    clients: 'Clients activated',
    found: 'Clients',
    quarter: 'Quarter',
  },
  status: {
    [ELeadClientStatus.WAITING]: 'Lead',
    [ELeadClientStatus.REQUIRES_ATTENTION]: 'Lead',
    [ELeadClientStatus.DRAFT]: 'Contact',
    [ELeadClientStatus.ACCEPTED]: 'Confirmed',
    [ELeadClientStatus.ERROR]: 'Disabled',
    [ELeadClientStatus.CANCELLED]: 'Expired',
  },
  createContact: {
    createTitle: 'Create contact',
    editTitle: 'Edit contact',
    companyName: 'Company name',
    contactName: 'Company contact person',
    phone: 'Phone number',
    email: 'Email (optional)',
    comment: 'Comment (optional)',
  },
  successContactModal: {
    title: 'Contact created!',
    description:
      'The edna manager will continue working with this contact. The contact will move to Lead status once the manager contacts them and selects commercial terms.',
    wellDone: 'Well done',
  },
  allEmpty: {
    subtitle:
      'You don’t have any registered clients, leads, or contacts yet. \n' +
      'Start by creating a contact and forwarding it to your edna manager.',
  },
  clientStatus: 'Client status:',
  contactCard: {
    companyInfo: 'Company details',
    companyName: 'Company name:',
    contactName: 'Company contact person:',
    phone: 'Phone number:',
    email: 'Email:',
    comment: 'Comment',
    edit: 'Edit details',
  },
  leadCard: {
    responsibleManagerId: 'Assigned edna manager',
    tariffsInfo: 'Pricing',
  },
};
